import { MESSAGE_COMPONENT_TYPE } from './message-cpt';

export const IM_RECEIVE_TYPE = {
  private: 1, // 私聊
  audio_channel: 2, // 语音频道IM消息
  text_channel: 3, // 文字频道IM消息
  // 4 被使用了
  chat_group: 5, // 群聊IM消息
  global_team: 6, // 全局组队聊天室IM消息
};
export enum PARSE_LINK_TYPE {
  'invite' = 1, // 邀请链接
  'normal', // 普通链接
  'video', // 视频链接
  'crosshair', // 准星链接
}

export interface IFileInfo {
  mimetype: string;
  fsize: string;
  width: number;
  height: number;
}

export type FileInfoList = Array<IFileInfo>;

/**
 * 消息列表接口中返回的消息类型
 */
export enum IM_MSG_TYPE {
  'pure_text' = 1, // 最初版本纯文本
  'html', // html格式富文本 2
  'img', // 图片 3
  'markdown', // Markdown格式富文本 4
  'teamCard', // 组队卡片 5
  'textAndImg', // 图文消息 6
  'sticker', // 大图emoji 7
  'teamInvite', // 开黑邀约 8
  'uploadFile', // 上传文件 9
  'AtOrChannel', // 带@或#的消息 10
  'channelAnc', //频道内公告 11
  'bot', // bot 卡片消息 12
  'teamCardV2', // 组队卡片V2 13
  'welcomeMsg', //欢迎信息  14
  'cdKey', // cdkey 15
  'postComment', // 帖子评论 16
  'post', // 帖子 17
  'vote', // 投票卡片 18
  'voteAnc', // 投票公告 19
  'customCard', // 自定义卡片 20
  'punishNotify' = 22, // 惩罚通知 22
  'fight' = 23, //开黑名片
  'miniProgram' = 24, // 小程序卡片
  'miniProDetail' = 25, // 小程序详情卡片
  'screenShareGift' = 26, // 屏幕共享礼物
  'feedbackCard' = 27, // 反馈卡片
  'groupAnnouncement' = 29, // 群公告
  'chatGroupUniversal' = 30, // 聊天群提示
  'globalTeamVoiceInvite' = 31, // 全局组队语音邀请
  'heyboxMiniProgramCard' = 32, // 黑盒小程序
  'personalBusinessCard' = 33, // 个人名片
  'groupChatBusinessCard' = 34, // 群聊名片
  'gameDetailCard' = 35, // 游戏详情卡片
  'activityCard' = 36, // 活动卡片
  'commentCard' = 37, // 评论卡片
  'bbsArticleCard' = 38, // 帖子卡片
  'heyboxGameCard' = 39, // 小黑盒游戏卡片
  'unknownPost' = 1001, // 未知帖子
}

/**
 * 根据消息获取渲染组件名
 * @description 在 MessageFactory 中使用，用来确定消息类型对应的渲染组件
 */
export function MESSAGE_CONTENT_COMPONENT(data: {
  msg_type: IM_MSG_TYPE;
  msg?: string;
  img?: string;
  [key: string]: any;
}) {
  // 处理 textAndImg 的特殊情况
  if (data.msg_type === IM_MSG_TYPE.textAndImg && data.msg && data.img) {
    return MESSAGE_COMPONENT_TYPE.TEXT_AND_IMG;
  }

  // 处理 textAndImg 只有 msg 的情况
  if (data.msg_type === IM_MSG_TYPE.textAndImg && data.msg) {
    return MESSAGE_COMPONENT_TYPE.TEXT;
  }

  // 处理 textAndImg 只有 img 的情况
  if (data.msg_type === IM_MSG_TYPE.textAndImg && data.img) {
    return MESSAGE_COMPONENT_TYPE.IMG;
  }

  // 处理其他文本类型
  if (
    [
      IM_MSG_TYPE.pure_text,
      IM_MSG_TYPE.html,
      IM_MSG_TYPE.markdown,
      IM_MSG_TYPE.AtOrChannel,
      IM_MSG_TYPE.globalTeamVoiceInvite,
    ].includes(data.msg_type)
  ) {
    return MESSAGE_COMPONENT_TYPE.TEXT;
  }

  // 使用 switch 处理其他情况
  switch (data.msg_type) {
    case IM_MSG_TYPE.img:
      return MESSAGE_COMPONENT_TYPE.IMG;
    case IM_MSG_TYPE.sticker:
      return MESSAGE_COMPONENT_TYPE.STICKER;
    case IM_MSG_TYPE.teamInvite:
      return MESSAGE_COMPONENT_TYPE.TEAM_INVITE;
    case IM_MSG_TYPE.uploadFile:
      return MESSAGE_COMPONENT_TYPE.UPLOAD_FILE;
    case IM_MSG_TYPE.teamCard:
      return MESSAGE_COMPONENT_TYPE.TEAM_CARD;
    case IM_MSG_TYPE.teamCardV2:
      return MESSAGE_COMPONENT_TYPE.TEAM_CARD_V2;
    case IM_MSG_TYPE.channelAnc:
      return MESSAGE_COMPONENT_TYPE.ANCCard;
    case IM_MSG_TYPE.bot:
      return MESSAGE_COMPONENT_TYPE.BOT;
    case IM_MSG_TYPE.welcomeMsg:
      return MESSAGE_COMPONENT_TYPE.WELCOME_MSG;
    case IM_MSG_TYPE.cdKey:
      return MESSAGE_COMPONENT_TYPE.CD_KEY;
    case IM_MSG_TYPE.postComment:
      return MESSAGE_COMPONENT_TYPE.POST_COMMENT;
    case IM_MSG_TYPE.post:
      return MESSAGE_COMPONENT_TYPE.POST;
    case IM_MSG_TYPE.unknownPost:
      return MESSAGE_COMPONENT_TYPE.UNKNOWN_POST;
    case IM_MSG_TYPE.vote:
      return MESSAGE_COMPONENT_TYPE.VOTE;
    case IM_MSG_TYPE.voteAnc:
      return MESSAGE_COMPONENT_TYPE.VOTE_ANC;
    case IM_MSG_TYPE.customCard:
      return MESSAGE_COMPONENT_TYPE.CUSTOM_CARD;
    case IM_MSG_TYPE.punishNotify:
      return MESSAGE_COMPONENT_TYPE.PUNISH_NOTIFY;
    case IM_MSG_TYPE.fight:
      return MESSAGE_COMPONENT_TYPE.FIGHT;
    case IM_MSG_TYPE.miniProgram:
      return MESSAGE_COMPONENT_TYPE.MINI_PROGRAM;
    case IM_MSG_TYPE.miniProDetail:
      return MESSAGE_COMPONENT_TYPE.MINI_PRO_DETAIL;
    case IM_MSG_TYPE.screenShareGift:
      return MESSAGE_COMPONENT_TYPE.SCREEN_SHARE_GIFT;
    case IM_MSG_TYPE.feedbackCard:
      return MESSAGE_COMPONENT_TYPE.FEEDBACK_CARD;
    case IM_MSG_TYPE.chatGroupUniversal:
      return MESSAGE_COMPONENT_TYPE.CHAT_GROUP_UNIVERSAL;
    case IM_MSG_TYPE.groupAnnouncement:
      return MESSAGE_COMPONENT_TYPE.GROUP_ANNOUNCEMENT;
    case IM_MSG_TYPE.heyboxMiniProgramCard:
    case IM_MSG_TYPE.personalBusinessCard:
    case IM_MSG_TYPE.groupChatBusinessCard:
      return MESSAGE_COMPONENT_TYPE.TOOL_CARD;
    case IM_MSG_TYPE.activityCard:
    case IM_MSG_TYPE.bbsArticleCard:
      return MESSAGE_COMPONENT_TYPE.INFO_CARD;
    case IM_MSG_TYPE.commentCard:
      return MESSAGE_COMPONENT_TYPE.COMMENT_CARD;
    case IM_MSG_TYPE.gameDetailCard:
      return MESSAGE_COMPONENT_TYPE.HEYBOX_GAME_CARD;
    default:
      return '';
  }
}

export const MESSAGE_MINE_DIRECTION_TGRESHOLD = 1094;

// 本地发送的IM消息标记
export const LOCAL_SEND_LOADING_MSG_TAG = ':self_msg';
// 数美审核不通过的IM消息标记
export const RISK_SEND_MSG_TAG = ':risk_msg';
// 检查是否id对应的消息是本地发送还没返回的消息
export function CHECK_IS_MSG_LOCAL_LOADING(id) {
  return id && String(id).includes(LOCAL_SEND_LOADING_MSG_TAG);
}

// 切换频道时需要重置的IM数据
export const CHANNEL_IM_RESET_DATA = {
  origin_messages: [],
  show_messages: [],
  newest_seq: -2,
  oldest_seq: -2,
  unreadMsgNum: 0,
  isLastMsgInScreen: false,
  notifySubmenu: [],
  inviteCode: '',
  inviteLink: '',
  show_pin_center: false,
  richTextInput: undefined,
  titleMenuTrigger: null,
  notifySettingTrigger: null,
  inviteMenuTrigger: null,
  isHistoryMode: false,
  imMsgInit: false,
  last_unread_message_id: 0,
  last_read_time: 0,
};

// 离开频道时需要缓存的IM数据
export const CHANNEL_IM_CACHE_KEYS = [
  'origin_messages',
  'newest_seq',
  'oldest_seq',
  'unreadMsgNum',
  'isLastMsgInScreen',
  'richTextInput',
  'isHistoryMode',
  'jumpAtMsg',
  'newMsgNum',
];

// 离开私聊时需要缓存的私聊数据
export const PRIVATE_CACHE_KEYS = [
  'origin_messages',
  'oldest_seq',
  'newest_seq',
  'old_ts',
  'hasMoreMsg',
  'emptyText',
];

// 离开群聊时需要缓存的群聊数据
export const GROUP_CACHE_KEYS = [
  'origin_messages',
  'oldest_seq',
  'newest_seq',
  'old_ts',
  'hasMoreMsg',
];

export const EDIT_IM_MSG_DURATION = 24 * 60 * 60 * 1000;

export const ORIGIN_MESSAGES_CACHE_LENGTH_LIMIT = 80;

/**
 * CARD_WRAPPER样式对应的消息类型
 */
export const CARD_WRAPPER_MESSAGE_COMPONENTS = [
  IM_MSG_TYPE.teamCard,
  IM_MSG_TYPE.channelAnc,
  IM_MSG_TYPE.teamCardV2,
  IM_MSG_TYPE.customCard,
];

/**
 * 新卡片包装消息类型
 * 卡片最大宽度=取（IM区域宽度的70%）和（IM区域宽度-176）和（400）最小值
 */
export const NEW_CARD_WRAPPER_MESSAGE_COMPONENTS = [
  /**
   * ToolCard
   */
  IM_MSG_TYPE.heyboxMiniProgramCard,
  IM_MSG_TYPE.personalBusinessCard,
  IM_MSG_TYPE.groupChatBusinessCard,
  /**
   * InfoCard
   */
  IM_MSG_TYPE.activityCard,
  IM_MSG_TYPE.bbsArticleCard,
];
